import React, { Component, useState } from "react";
import {
  GoogleMap,
  LoadScript,
  Marker,
  MarkerClusterer,
} from "@react-google-maps/api";
import {
  APIHandler,
  BackButton,
  PremiumHotel,
  FreeHotel,
  StorageHandler,
} from "C4";
import { baseAppId, storageKeys } from "settings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { Multiselect } from "multiselect-react-dropdown";
import i18n from "i18n-react";

import SimpleBarReact from "simplebar-react";
import "simplebar/src/simplebar.css";

import MarkerFree from "assets/images/ab-mapGrey.png";
import ClusterFree from "assets/images/ab-mapClusterGrey.png";
import MarkerPremium from "assets/images/ab-map.png";
import ClusterPremium from "assets/images/ab-mapCluster.png";

let containerStyle = {
  width: "100%",
  height: "calc(100vh - 8rem)",
};
const params = new URLSearchParams(window.location.search);
if (params.get("mobile")) {
  containerStyle = {
    width: "100%",
    height: "100vh",
  };
}

const clusterPremium = {
  styles: [
    {
      url: ClusterPremium,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

const clusterFree = {
  styles: [
    {
      url: ClusterFree,
      width: 35,
      height: 51,
      textColor: "white",
      textSize: 14,
      fontFamily: "Source Sans Pro",
    },
  ],
  clusterClass: "clusterIcon",
};

export default class DirectoryView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      premiumHotelsList: [],
      freeHotelsList: [],
      lat1: 28.69416362102856,
      lat2: 27.296091473729827,
      lon1: -80.95860201566795,
      lon2: -82.33051974027732,
      loading: false,
      query: "",
      category: "",
      michelin: "",
      rating: "",
      cuisine: "",
      width: null,
      mobile: false,
      zoom: 10,
      center: {
        lat: 27.95484,
        lng: -81.726662,
      },
      color: "0069aa",
      font: "Source Sans Pro",
      userInfo: "",
      cuisines: [
        { name: "All", id: "cuisine" },
        { name: "Brasserie", id: "cuisine" },
        { name: "Fine Dining", id: "cuisine" },
        { name: "International", id: "cuisine" },
        { name: "Italian", id: "cuisine" },
        { name: "Mediterranean", id: "cuisine" },
        { name: "Option vegan", id: "cuisine" },
        { name: "Pizzeria and Creperie", id: "cuisine" },
        { name: "Traditional French", id: "cuisine" },
      ],
      michelins: [
        { name: "All", id: "michelin" },
        { name: "3 STARS MICHELIN", id: "michelin" },
        { name: "2 STARS MICHELIN", id: "michelin" },
        { name: "1 STARS MICHELIN", id: "michelin" },
      ],
      stars: [
        { name: "All", id: "rating" },
        { name: "5 stars", id: "rating" },
        { name: "4 stars", id: "rating" },
        { name: "3 stars", id: "rating" },
      ],
      categories: [
        { name: "All", id: "category" },
        { name: "Resorts", id: "category" },
        { name: "Winter Haven-Auburndale", id: "category" },
        { name: "Davenport-ChampionsGate", id: "category" },
        { name: "Lake Wales-Haines City", id: "category" },
        { name: "Lakeland", id: "category" },
        { name: "Bartow-Mulberry", id: "category" },
        { name: "Vacation Rental & Condo Hotels", id: "category" },
        { name: "RV, Lodge, and Camping", id: "category" },
      ],
      filterOpen: false,
      logo: null,
    };

    this.onSelect = this.onSelect.bind(this);
    this.onRemove = this.onRemove.bind(this);
  }

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    const width =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;

    let mobile = false;
    if (params.get("mobile")) {
      mobile = true;
    }
    this.setState({ mobile: mobile, width: width });

    if (width < 800) {
      this.getHotelsList();
    }
    this.getLogo();
  }

  async getLogo() {
    const appInfo = await StorageHandler.load(storageKeys.appInfo);
    if (appInfo) {
      this.setState({
        logo: appInfo.logoWhite,
      });
    }
  }

  handleInputChange = () => {
    this.setState(
      {
        query: this.search.value,
      },
      this.getHotelsList()
    );
  };

  loadProperties(bounds, zoom) {
    this.setState({
      lat1: bounds.getNorthEast().lat(),
      lat2: bounds.getSouthWest().lat(),
      lon1: bounds.getNorthEast().lng(),
      lon2: bounds.getSouthWest().lng(),
      zoom: zoom,
    });
    this.getHotelsList();
  }

  getHotelsList() {
    this.setState({ loading: true });
    setTimeout(() => {
      const {
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating,
      } = this.state;
      APIHandler.getFreeHotelsList(
        lat1,
        lat2,
        lon1,
        lon2,
        query,
        category,
        cuisine,
        michelin,
        rating
      ).then((results) => {
        this.setState({ freeHotelsList: results, loading: false });
      });
    }, 200);

    // APIHandler.getPremiumHotelsList(lat1, lat2, lon1, lon2).then((results) => {
    //   this.setState({ premiumHotelsList: results.items });
    // });
  }

  flyToMarker = (lat, lon) => {
    this.setState({
      zoom: 20,
      center: {
        lat: Number(lat),
        lng: Number(lon),
      },
    });
  };

  resetMap = () => {
    this.setState({
      zoom: 15,
      center: {
        lat: 27.95484,
        lng: -81.726662,
      },
    });
  };

  resetFilters = () => {
    window.location.reload(false);
  };

  premiumInfo = (userInfoID) => {
    document.getElementById("iframe").classList.remove("hide");
    this.setState({
      userInfo: `https://travproconnect.com/profile/${userInfoID}?app_id=${baseAppId}`,
    });
  };

  freeInfo = (userInfoID) => {
    console.log(userInfoID);
    if (this.state.mobile) {
      window.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=100&mobile=true&header=false`,
        "*"
      );
      window.ReactNativeWebView.postMessage(
        `webview:https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10&mobile=true&header=false`,
        "*"
      );
    } else {
      document.getElementById("iframe").classList.remove("hide");
      this.setState({
        userInfo: `https://travpro.yourworldapps.nl/profile-web.php?app_id=${baseAppId}&rooms=no&id=${userInfoID}&color=${this.state.color}&font=${this.state.font}&zoom=10`,
      });
    }
  };

  onSelect(selectedList, selectedItem) {
    this.setState(
      {
        [selectedItem.id]: selectedItem["name"],
      },
      () => {
        this.getHotelsList();
      }
    );
  }

  onRemove(selectedList, removedItem) {
    const array = [...this.state[removedItem.id]];
    const index = array.indexOf(removedItem["name"]);
    if (index !== -1) {
      array.splice(index, 1);
      this.setState(
        {
          [removedItem.id]: array,
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  }

  handleCheck = (e) => {
    if (this.state[e.target.id] === "") {
      this.setState(
        {
          [e.target.id]: 1,
        },
        () => {
          this.getHotelsList();
        }
      );
    } else {
      this.setState(
        {
          [e.target.id]: "",
        },
        () => {
          this.getHotelsList();
        }
      );
    }
  };

  closeIframe() {
    document.getElementById("iframe").classList.add("hide");
  }

  toggleFilter = () => {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  };

  render() {
    const {
      premiumHotelsList,
      freeHotelsList,
      zoom,
      center,
      userInfo,
      mobile,
      width,
      loading,
      filterOpen,
      logo,
      category,
    } = this.state;

    return (
      <div className="directoryContainer">
        {!mobile && (
          <div className="header">
            <BackButton
              useHistory={false}
              text={i18n.translate("general.back")}
            />
            <div className="search">
              <FontAwesomeIcon
                icon={["fas", "search"]}
                className="searchIcon"
              />
              <input
                className="searchInput"
                placeholder={i18n.translate("directoryView.search")}
                type="text"
                ref={(input) => (this.search = input)}
                onChange={this.handleInputChange}
              />
            </div>
            <img src={logo} className="logo" alt="logo" />
          </div>
        )}
        {mobile && (
          <style>
            {
              "\
              .cookieConsent { display: none !important; } .directoryContainer { height: 100vh; } .results { top: 0 !important; } .listContainer { height: calc(100vh - 22rem) !important; margin-top: 0 !important; } @media screen and (min-width: 699px) { .listContainer { height: calc(100vh - 18rem) !important; } }"
            }
          </style>
        )}
        <div className="directoryView">
          <div className="leftSide">
            <div className="results">
              {i18n.translate("directoryView.amountOfResults")}
              {freeHotelsList.length + premiumHotelsList.length}
              <button
                onClick={filterOpen ? this.toggleFilter : this.toggleFilter}
                className="filter-btn"
              >
                {filterOpen
                  ? i18n.translate("general.close")
                  : i18n.translate("directoryView.filter")}
              </button>
            </div>
            <div className="leftGrid">
              <div className={`filterContainer ${filterOpen ? "active" : ""}`}>
                <div className="type">
                  <Multiselect
                    options={this.state.categories}
                    selectedValues={this.state.selectedValue}
                    onSelect={this.onSelect}
                    onRemove={this.onRemove}
                    displayValue="name"
                    placeholder="Filter by Category"
                    showArrow={true}
                    avoidHighlightFirstOption={true}
                    singleSelect={true}
                  />
                </div>
                {category === "Accommodation" && (
                  <div className="price">
                    <Multiselect
                      options={this.state.stars}
                      selectedValues={this.state.selectedValue}
                      onSelect={this.onSelect}
                      onRemove={this.onRemove}
                      displayValue="name"
                      placeholder="Stars"
                      showArrow={true}
                      avoidHighlightFirstOption={true}
                      singleSelect={true}
                    />
                  </div>
                )}
                {category === "Restaurant" && (
                  <div className="price">
                    <Multiselect
                      options={this.state.cuisines}
                      selectedValues={this.state.selectedValue}
                      onSelect={this.onSelect}
                      onRemove={this.onRemove}
                      displayValue="name"
                      placeholder="Cuisine"
                      showArrow={true}
                      avoidHighlightFirstOption={true}
                      singleSelect={true}
                    />
                  </div>
                )}
                {category === "Restaurant" && (
                  <div className="price">
                    <Multiselect
                      options={this.state.michelins}
                      selectedValues={this.state.selectedValue}
                      onSelect={this.onSelect}
                      onRemove={this.onRemove}
                      displayValue="name"
                      placeholder="Michelin Stars"
                      showArrow={true}
                      avoidHighlightFirstOption={true}
                      singleSelect={true}
                    />
                  </div>
                )}

                <div
                  className="resetFilters"
                  onClick={() => {
                    this.resetFilters();
                  }}
                >
                  {i18n.translate("directoryView.resetFilters")} >
                </div>
                <div className="text-center">
                  <button
                    onClick={this.resetFilters}
                    className="filter-btn inverted"
                  >
                    {i18n.translate("directoryView.resetFilters")}
                  </button>
                  <button onClick={this.toggleFilter} className="show-results">
                    {i18n.translate("directoryView.showResults")}
                  </button>
                </div>
              </div>

              {mobile && (
                <div className="search">
                  <FontAwesomeIcon
                    icon={["fas", "search"]}
                    className="searchIcon"
                  />
                  <input
                    className="searchInput"
                    placeholder={i18n.translate("directoryView.search")}
                    type="text"
                    ref={(input) => (this.search = input)}
                    onChange={this.handleInputChange}
                  />
                </div>
              )}

              <SimpleBarReact
                className={`listContainer ${filterOpen ? "filterOpen" : ""}`}
              >
                <div className="premiumList">
                  {loading && (
                    <span className="loader">
                      <FontAwesomeIcon icon={["fas", "circle-notch"]} spin />
                    </span>
                  )}
                  {premiumHotelsList.length > 0 &&
                    premiumHotelsList.map((hotel) => (
                      <PremiumHotel
                        key={hotel.id}
                        id={hotel.id}
                        bgImage={hotel.headerImages[0]}
                        propertyName={hotel.propertyName}
                        flyToMarker={() => {
                          this.flyToMarker(
                            hotel.coords.latitude,
                            hotel.coords.longitude
                          );
                        }}
                        hotelInfo={() => {
                          this.premiumInfo(hotel.userInfoID);
                        }}
                      />
                    ))}
                </div>
                <div className="freeList">
                  {freeHotelsList.length === 0 && !loading && (
                    <div className="noResults">
                      {i18n.translate("directoryView.noResults")}
                    </div>
                  )}
                  {/* Filter duplicates, because items are created for each category and can't have multiple */}
                  {freeHotelsList.length > 0 &&
                    freeHotelsList.map((hotel, i) => (
                      <React.Fragment key={hotel.company_listing_id}>
                        <FreeHotel
                          id={hotel.company_listing_id}
                          bgImage={hotel.img_path + hotel.photo_file}
                          flyToMarker={() => {
                            this.flyToMarker(hotel.latitude, hotel.longitude);
                          }}
                          hotelInfo={() => {
                            this.freeInfo(hotel.listing_id);
                          }}
                          hotelName={hotel.company}
                          location={hotel.state}
                          item={hotel}
                        />
                      </React.Fragment>
                    ))}
                  {zoom > 8 && (
                    <div
                      className="resetMap"
                      onClick={() => {
                        this.resetMap();
                      }}
                    >
                      {i18n.translate("directoryView.resetMap")}
                    </div>
                  )}
                </div>
              </SimpleBarReact>
            </div>
          </div>
          {width > 700 && (
            <div className="rightSide">
              <LoadScript googleMapsApiKey="AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc">
                <GoogleMap
                  mapContainerStyle={containerStyle}
                  center={center}
                  zoom={zoom}
                  onLoad={(map) => {
                    this.map = map;
                  }}
                  onIdle={() => {
                    this.loadProperties(
                      this.map.getBounds(),
                      this.map.getZoom()
                    );
                  }}
                >
                  {/* Child components, such as markers, info windows, etc. */}
                  <MarkerClusterer
                    minimumClusterSize={4}
                    gridSize={100}
                    options={clusterFree}
                  >
                    {(clusterer) => {
                      return (
                        freeHotelsList.length > 0 &&
                        freeHotelsList.map((freeHotel) => (
                          <Marker
                            key={freeHotel.listing_id}
                            position={{
                              lat: Number(freeHotel.latitude),
                              lng: Number(freeHotel.longitude),
                            }}
                            icon={MarkerFree}
                            onClick={() => {
                              this.flyToMarker(
                                freeHotel.latitude,
                                freeHotel.longitude
                              );
                            }}
                            clusterer={clusterer}
                          />
                        ))
                      );
                    }}
                  </MarkerClusterer>
                  <MarkerClusterer
                    minimumClusterSize={5}
                    options={clusterPremium}
                  >
                    {(clusterer) => {
                      return (
                        premiumHotelsList.length > 0 &&
                        premiumHotelsList.map((premiumHotel) => (
                          <Marker
                            key={premiumHotel.id}
                            position={{
                              lat: premiumHotel.coords.latitude,
                              lng: premiumHotel.coords.longitude,
                            }}
                            icon={MarkerPremium}
                            onClick={() => {
                              this.flyToMarker(
                                premiumHotel.coords.latitude,
                                premiumHotel.coords.longitude
                              );
                            }}
                            clusterer={clusterer}
                          ></Marker>
                        ))
                      );
                    }}
                  </MarkerClusterer>
                </GoogleMap>
              </LoadScript>
            </div>
          )}

          <div className="iframe hide" id="iframe">
            <div
              className="bgIframe"
              onClick={() => {
                this.closeIframe();
              }}
            ></div>
            <div className="iframeHolder">
              <div
                className="closeIframe"
                href="#"
                onClick={() => {
                  this.closeIframe();
                }}
              >
                <span className="closeText">
                  <FontAwesomeIcon icon={["fas", "chevron-left"]} />{" "}
                  {i18n.translate("general.back")}
                </span>
              </div>
              <div className="contentIframe">
                <iframe
                  width="100%"
                  height="100%"
                  id="iframeModal"
                  src={userInfo}
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
